// Multivariate Dependencies
import React from 'react';
// Components
import { Icon } from '../../Icon';
import { Container } from '../../../common/styles/container';
import { Paragraph } from '../../Paragraph';
import { PrefixLabel } from '../../PrefixLabel';
// Types
import { DropdownItemState } from '../types/DropdownItemProps';
export var DropdownItemStructure = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.state, state = _b === void 0 ? DropdownItemState.DEFAULT : _b, icon = _a.icon, id = _a.id, prefixLabel = _a.prefixLabel, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseMove = _a.onMouseMove;
    return (React.createElement(Container, { className: className, role: 'listitem', key: id, tabIndex: -1, onClick: state === DropdownItemState.DEFAULT ? onClick : undefined, onMouseEnter: state === DropdownItemState.DEFAULT ? onMouseEnter : undefined, onMouseLeave: state === DropdownItemState.DEFAULT ? onMouseLeave : undefined, onMouseMove: state === DropdownItemState.DEFAULT ? onMouseMove : undefined },
        icon && React.createElement(Icon, { name: icon, ariaLabel: children }),
        React.createElement(Paragraph, { size: 'xsmall' },
            prefixLabel && React.createElement(PrefixLabel, { styleVariant: 'grey' }, prefixLabel),
            children)));
};
//# sourceMappingURL=DropdownItemStructure.js.map